import { render, staticRenderFns } from "./out-collection-import.vue?vue&type=template&id=ac0296b4&scoped=true"
import script from "./out-collection-import.vue?vue&type=script&lang=ts"
export * from "./out-collection-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0296b4",
  null
  
)

export default component.exports